var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showOrderLink)?_c('a',{staticClass:"order-number",attrs:{"href":_vm.orderUrl,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.orderInformation.orderDisplayId)+" ")]):_c('span',[_vm._v(" "+_vm._s(_vm.orderInformation.orderDisplayId)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }